<script lang="ts" setup></script>

<template>
    <div class="pb-5">
        <h3 class="text-base font-semibold leading-6 text-gray-900">
            <slot name="name" />
        </h3>
        <p class="mt-2 max-w-4xl text-sm text-gray-500">
            <slot name="description" />
        </p>
    </div>
</template>
